import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import style from './style.module.less';

const url = '//ship.shipstation.com/settings/warehouses';

const message = defineMessages({
  hasApiError: {
    description: 'USPS Pickup Page Placeholder API error text',
    defaultMessage: 'There was a problem retrieving data from the API. Please try again later.',
    id: 'TpbpIl',
  },
  noShipFrom: {
    description: 'USPS Pickup Page Placeholder no shipFrom Text',
    defaultMessage: 'Ship From location required to request USPS Pickup,{linebreak}you can <a>enter your Ship From here</a>.',
    id: 'v0725s',
  },
});

const hasApiErrorMessage = <FormattedMessage {...message.hasApiError} />;

const noShipFromMessage = (
  <FormattedMessage
    {...message.noShipFrom}
    values={{
      linebreak: <br />,
      a: (chunks) => <a href={url}>{chunks}</a>,
    }}
  />
);

const renderMessage = (hasError) => {
  const displayMessage = hasError ? hasApiErrorMessage : noShipFromMessage;
  return displayMessage;
};

const UspsPickupPlaceholder = ({ hasApiError }) => {
  return (
    <div className={style['pickup-placeholder']}>
      <div>{renderMessage(hasApiError)}</div>
    </div>
  );
};

UspsPickupPlaceholder.propTypes = {
  hasApiError: PropTypes.bool.isRequired,
};

export default UspsPickupPlaceholder;
